import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'roadClassName'
})
@Injectable({
  providedIn: 'root'
})
export class RoadClassNamePipe implements PipeTransform {

  constructor(
  ) {
  }

  transform(roadClass: any) {
    return roadClass.name ? (roadClass.name === '1' ? 'Dálnice' : 'I' + (roadClass.name === '2' ? '' : 'I' + (roadClass.name === '3' ? '' : 'I' )) + '. třída') : null;
  }
}
